import TransferDetails from 'features/v2a/sender/screens/TransferDetails/TransferDetails';
import React from 'react';

export default function Page() {
  return <TransferDetails />;
}
